import { render, staticRenderFns } from "./DetailPermohonanDokumenLengkap.vue?vue&type=template&id=430b3ff2&"
import script from "./DetailPermohonanDokumenLengkap.vue?vue&type=script&lang=js&"
export * from "./DetailPermohonanDokumenLengkap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports